import { Injectable, InjectionToken, Optional, Inject } from '@angular/core';
import { Observable, Scheduler, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as clientParentActions from '../actions/client-parents';
import { ClientParentService } from '../services/client-parents.service';
import { ClientParent } from '../models/client-parent';
import * as userActions from '../../users/actions/users';

export const SEARCH_DEBOUNCE = new InjectionToken<number>('Search Debounce');
export const SEARCH_SCHEDULER = new InjectionToken<Scheduler>('Search Scheduler');

@Injectable()
export class ClientParentEffects {

  
  triggerGet$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<userActions.Load>(userActions.LOAD),
    map(() => new clientParentActions.Load())
  ));

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<clientParentActions.Load>(clientParentActions.LOAD),
    switchMap(() => {
      return this.clientParentService.getAllClientParents().pipe(
        map((clientParents: ClientParent[]) => new clientParentActions.LoadComplete(clientParents)),
        catchError(err => of(new clientParentActions.LoadError(err)))
      );
    })));

  constructor(
    private actions$: Actions,
    private clientParentService: ClientParentService,
    @Optional()
    @Inject(SEARCH_DEBOUNCE)
    private debounce: number = 300,
    @Optional()
    @Inject(SEARCH_SCHEDULER)
    private scheduler: Scheduler) {
  }
}
